var map = {
	"./CD/TAOD.jpg": 242,
	"./CD/TAOD2.jpg": 243,
	"./DVD/6TunasDouro.jpg": 244,
	"./DVD/6TunasDouro2.jpg": 245,
	"./DVD/6TunasDouro3.jpg": 246,
	"./DVD/6TunasDouro4.jpg": 247,
	"./DVD/XVAniversario.jpg": 248,
	"./DVD/XVAniversario2.jpg": 249,
	"./Emblema/emblemaTAOD.jpg": 250,
	"./Emblema/emblemaTAOD2.jpg": 67,
	"./Pins/pins.jpg": 251,
	"./Pins/pins2.jpg": 252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 241;